import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/ShadersInclude/vertexColorMixing.js
var name, shader;
var init_vertexColorMixing = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/vertexColorMixing.js"() {
    "use strict";
    init_shaderStore();
    name = "vertexColorMixing";
    shader = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
vColor=vec4(1.0);
#ifdef VERTEXCOLOR
#ifdef VERTEXALPHA
vColor*=color;
#else
vColor.rgb*=color.rgb;
#endif
#endif
#ifdef INSTANCESCOLOR
vColor*=instanceColor;
#endif
#endif
`;
    ShaderStore.IncludesShadersStore[name] = shader;
  }
});

export {
  init_vertexColorMixing
};
